


























































import {
	ref,
	defineComponent,
	PropType,
	computed,
} from '@vue/composition-api';
import { Size } from '@front-app/components/constants';
import { scrollTo } from '@front-app/directives/scrollTo';
import { PartialUser } from '@front-app/services/UserApi/UserModel';
import { UserAvatarStore } from '@front-app/store/singletons/User';
import SearchResult from '@front-app/components/search/SearchResult.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import { useUsername } from '@front-app/hooks/useTranslate';
import { STATUS } from '@front-app/constants/state';
import { useStatus } from '@front-app/hooks/useAsyncStatus';
import LoaderState from '@front-app/components/LoaderState.vue';

export default defineComponent({
	components: {
		UserAvatar,
		SearchResult,
		LoaderState,
	},

	directives: { scrollTo },

	props: {
		items: {
			type: Array as PropType<PartialUser[]>,
			required: true,
		},
		mentionFetchStatus: {
			type: String as PropType<STATUS>,
			required: true,
		},
	},

	setup(props, ctx) {
		const selectedIndex = ref(0);

		const selectItem = (index: number): void => {
			const item = props.items[index];

			if (item) {
				ctx.emit('select-mention', item);
			}
		};

		const {
			isUnstarted: isFetchUnstarted,
			isLoading: isLoadingMoreMentions,
		} = useStatus(computed(() => props.mentionFetchStatus));

		return {
			isFetchUnstarted,
			isLoadingMoreMentions,
			selectedIndex,
			selectItem,
			getUsername: useUsername(ctx),
			// Util
			Size,
			// Avatar
			fetchAvatar: UserAvatarStore.fetch,
			getAvatar: UserAvatarStore.get,
		};
	},

	watch: {
		items(): void {
			this.selectedIndex = 0;
		},
	},

	methods: {
		onKeyDown({ event }: { event: KeyboardEvent}): boolean {
			if (event.key === 'ArrowUp') {
				this.upHandler();
				return true;
			}

			if (event.key === 'ArrowDown') {
				this.downHandler();
				return true;
			}

			if (event.key === 'Enter') {
				this.enterHandler();
				return true;
			}

			return false;
		},

		upHandler(): void {
			this.selectedIndex = ((this.selectedIndex + this.items.length) - 1) % this.items.length;
		},

		downHandler(): void {
			this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
		},

		enterHandler(): void {
			this.selectItem(this.selectedIndex);
		},
	},
});
